module.exports = __webpack_public_path__ + "static/img/1.47b31d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/1.png
// module id = Q7HK
// module chunks = 0